import { NgModule } from '@angular/core';

import { BackgroundColorDirective, ColorDirective } from './color.directive';
export class ColorModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    exports: [BackgroundColorDirective, ColorDirective],
    declarations: [BackgroundColorDirective, ColorDirective]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ColorModule_tsickle_Closure_declarations() {
/** @type {?} */
ColorModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ColorModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
